import React from "react";
import Container from "../components/Container";
import { cls } from "../utils/helpers";

export default function HomePage({ p, t }) {
  return (
    <>
      <section className={p.hero}>
        <Container>
          <div className="py-16">
            <h1 className={cls("text-4xl font-extrabold tracking-tight", p.cardTitle)}>
              {t("home.title")}
            </h1>
            <p className={cls("mt-3 max-w-2xl", p.paragraph)}>
              {t("home.subtitle")}
            </p>
            <div className="mt-8 flex gap-3">
              <a href="/prestations" className={p.ctaPrimary}>
                {t("home.cta.presta")}
              </a>
              <a href="/software" className={p.ctaSecondary}>
                {t("home.cta.software")}
              </a>
            </div>
          </div>
        </Container>
      </section>

      <section className="py-14">
        <Container>
          <div className="grid md:grid-cols-3 gap-6">
            {[t("home.card.1"), t("home.card.2"), t("home.card.3")].map(
              (title, i) => (
                <div key={i} className={p.card}>
                  <h3 className={cls("text-lg font-semibold", p.cardTitle)}>
                    {title}
                  </h3>
                  <p className={cls("mt-2 text-sm", p.cardP)}>
                    {t("home.card.desc")}
                  </p>
                  <a
                    href="/prestations"
                    className={cls(
                      "mt-4 inline-block text-sm underline underline-offset-4",
                      p.paragraph
                    )}
                  >
                    {t("home.card.link")}
                  </a>
                </div>
              )
            )}
          </div>
        </Container>
      </section>
    </>
  );
}
